import {gsap} from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import {CountUp} from "countup.js";

export class CountNumber {
  constructor() {
    this._numbers = document.querySelectorAll('[animation-number]')

    if (!this._numbers.length) return;

    this.init()
  }

  init() {
    gsap.registerPlugin(ScrollTrigger)

    this._numbers.forEach(number => {
      gsap.to(number, {
        scrollTrigger: {
          trigger: number,
          start: 'top 100%',
          scrub: true,
          onEnter: (e) => {
            this.countNumber(e)
          },
          once: true
        }
      })
    })
  }

  parseAnimationNumber(raw) {
    if (raw == null || raw === '') return null

    const match = String(raw).trim().match(/^([^\d\-+]*?)([\d]+(?:[.,]\d+)?)([\s\S]*)$/)

    if (!match) return null

    const endVal = parseFloat(match[2].replace(',', '.'))

    if (Number.isNaN(endVal)) return null

    return {
      endVal,
      prefix: match[1] ?? '',
      suffix: match[3] ?? '',
      decimalPlaces: (match[2].split(/[.,]/)[1] || '').length,
    }
  }

  countNumber(el) {
    const target = el.trigger
    const parsed = this.parseAnimationNumber(target.getAttribute('animation-number'))

    if (!parsed) return

    const count = new CountUp(target, parsed.endVal, {
      duration: 4,
      useGrouping: false,
      prefix: parsed.prefix,
      suffix: parsed.suffix,
      decimalPlaces: parsed.decimalPlaces,
    })

    if (!count.error) {
      count.start()
    }
  }
}
